<template>
    <div class="magazines">
        <div class="magazine">
          <el-tabs style="height: 80px;" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="会刊" name="journal" class="magazine-frame">
            </el-tab-pane>

            <el-tab-pane label="年鉴" name="yearbooks" class="magazine-frame">
            </el-tab-pane>
          </el-tabs>

          <div v-if="activeName == 'journal'"
            style="display: flex; flex-wrap: wrap;"
           >
            <div class="Con-journal" v-for="(item,index) in journalListCompute" :key="index" @click="openPdf(item.ossPath)">
              <!-- <pdf
                class="pdf"
                ref="pdf"
                :page="currentPage"
                :src="item.icon"
                style="background:#eee;">
              </pdf> -->
              <img :src="item.icon" class="pdf" alt="">
              <div class="periodicals">
                <a :title="item.intro">{{item.intro | limitWordText(10)}}</a>
              </div>
            </div>
          </div>

          <div v-if="activeName == 'yearbooks'" style="display: flex; flex-wrap: wrap;">
            <div class="Con-journal" v-for="(item,index) in yearbooksCompute" :key="index" @click="openPdf(item.ossPath)">
              <!-- <pdf
                ref="pdf"
                :page="currentPage"
                :src="item.icon">
              </pdf> -->
              <img :src="item.icon"  alt="">
              <div class="periodicals">
                <a :title="item.intro">{{item.intro.trim() | limitWordText(10)}}</a>
              </div>
            </div>
          </div>

        </div>
        <return-top></return-top>
    </div>
</template>

<script>
import ReturnTop from '@/components/returnTop.vue'
import mixins from '@/utils/mixin'
// import pdf from 'vue-pdf'
export default {
  name: 'magazine',
  mixins: [mixins],
  props: {

  },
  components: {
    ReturnTop
    // pdf
  },
  data () {
    return {
      currentPage: 1,
      activeName: 'journal',
      journalList: [], // 会刊
      yearbooks: [], // 年鉴
      journalListCompute: [], // 缓冲区会刊
      yearbooksCompute: [], // 缓冲区年鉴
      initNum: 8
    }
  },
  computed: {
    disabled () {
      return this.loading
    }
  },
  created () {
    this.association()
    this.annual()
  },
  mounted () {
    document.documentElement.scrollTop = 0
    this.$parent.activeIndex = '10'
    this.changeToJournal()
  },
  destroyed () {
    window.onscroll = function () {}
  },
  methods: {
    handleClick (data) {
      this.activeName = data.name
      if (this.activeName === 'journal') {
        this.changeToJournal()
      } else {
        this.changeToAnnual()
      }
    },
    changeToJournal () {
      this.journalListCompute = []
      this.journalListCompute.push.apply(this.journalListCompute, this.initMagazine(this.journalList))
      const that = this
      window.onscroll = function () {
        if (that.isBottom()) {
          // apply push方法将函数返回的数组推入缓冲区
          that.journalListCompute.push.apply(that.journalListCompute, that.addMagazineToCache(that.journalList, that.journalListCompute.length))
          console.log(that.journalListCompute.length)
        }
      }
    },
    changeToAnnual () {
      this.yearbooksCompute = []
      this.yearbooksCompute.push.apply(this.yearbooksCompute, this.initMagazine(this.yearbooks))
      const that = this
      window.onscroll = function () {
        if (that.isBottom()) {
          // apply push方法将函数返回的数组推入缓冲区
          that.yearbooksCompute.push.apply(that.yearbooksCompute, that.addMagazineToCache(that.yearbooks, that.yearbooksCompute.length))
        }
      }
    },
    // 初始渲染8个pdf 或更少
    initMagazine (data) {
      return data.slice(0, Math.min(data.length, this.initNum))
    },
    // 每次往缓冲区添加8个 或更少
    addMagazineToCache (data, count) {
      console.log(Math.min(data.length - count, this.initNum))
      if (data.length > count) {
        return data.slice(count - 1, count - 1 + Math.min(data.length - count, this.initNum))
      }
      return []
    },
    // 获取当前页面已经滚动的高度
    getScroll () {
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
    },
    // 用户当前高度
    clientHeight () {
      return document.documentElement.clientHeight
    },
    // 文档流的高度
    DOMHeight () {
      return document.body.scrollHeight
    },
    // 是否到达底部
    isBottom () {
      console.log('isBottom')
      console.log(this.getScroll() + this.clientHeight() > (this.DOMHeight() * 0.9183 - 385))
      return this.getScroll() + this.clientHeight() > (this.DOMHeight() * 0.9183 - 385)
    },
    // 杂志会刊
    async association () {
      const res = await this.$get(this.$url.magazine.association)
      const { code, msg, data } = res.data
      if (code === 200) {
        this.journalList = data
        this.journalListCompute.push.apply(this.journalListCompute, this.initMagazine(this.journalList))
      } else {
        this.$message.error(msg)
      }
    },
    // 杂志年刊
    async annual () {
      const res = await this.$get(this.$url.magazine.annual)
      const { code, msg, data } = res.data
      if (code === 200) {
        this.yearbooks = data
      } else {
        this.$message.error(msg)
      }
    },
    // 打开pdf
    openPdf (url) {
      window.open(url)
    }
  }
}
</script>

<style scoped lang="less">
.magazines{
  width: 100%;
  min-height: 100vh;
  font-size: 16px;
  background-color: #F5F5F5;
  margin-top: 8px;
  overflow: hidden;
}
.magazine{
  width: 1200px;
  min-height: 100vh;
  border-radius: 2px;
  background-color: #fff;
  margin: 10px auto 100px;
  box-sizing: border-box;
  padding: 23px;
}
.magazine-frame{
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: stretch;
  box-sizing: border-box;
  padding: 30px 0 50px;
  .Con-journal:nth-of-type(4n){
    margin-right: 0;
  }
  .Con-journal{
    display: flex;
    position: relative;
    // background-color: aqua;
    width: 271px;
    height: 363px;
    margin: 0 22px 65px 0;
    cursor: pointer;
    background-color: #eee;
    img{
      width: 271px;
      height: 363px;
    }
    .periodicals{
      position: absolute;
      bottom: -30px;
      left: 27px;
      width: 223px;
      height: 45px;
      line-height: 45px;
      font-size: 16px;
      background: #FFFFFF;
      box-shadow: 0px 4px 23px 0px rgba(0, 0, 0, 0.24);
      border-radius: 31px;
      text-align: center;
      color: #000 !important;
      /deep/.el-divider--vertical{
        width: 2px;
        height: 18px;
        margin: 0 10px;
        background-color: #999;
      }
    }
  }
}
/deep/.el-tabs__item{
  font-size: 20px;
  font-weight: 600;
  padding-bottom: 50px;
}
/deep/.is-active{
  color: #3056D9;
}
/deep/.el-tabs__active-bar{
  height: 4px;
  background-color: #3056D9;
  border-radius: 2px;
}

.Con-journal:nth-of-type(4n){
  margin-right: 0;
}
.Con-journal{
  display: flex;
  position: relative;
  // background-color: aqua;
  width: 271px;
  height: 363px;
  margin: 0 22px 65px 0;
  cursor: pointer;
  img{
    width: 271px;
    height: 363px;
  }
  .periodicals{
    position: absolute;
    bottom: -30px;
    left: 27px;
    width: 223px;
    height: 45px;
    line-height: 45px;
    font-size: 16px;
    background: #FFFFFF;
    box-shadow: 0px 4px 23px 0px rgba(0, 0, 0, 0.24);
    border-radius: 31px;
    text-align: center;
    color: #000;
    /deep/.el-divider--vertical{
      width: 2px;
      height: 18px;
      margin: 0 10px;
      background-color: #999;
    }
  }
}
</style>
